import React, { FunctionComponent } from 'react';

import { EditoList as EditoListType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import Buttons from '../../Buttons';
import Description from '../../Section/SellingPropositionList/Description';
import Title from '../../Section/SellingPropositionList/Title';
import Edito from './Edito';

export const EditoListFragment = graphql`
  fragment EditoListFragment on SanityEditoList {
    title {
      title
      level
    }
    upperText: upper_text
    bottomText: bottom_text
    variant {
      variant
    }
    ctas {
      ...CtaFragment
    }
    editos {
      ctas {
        ...CtaFragment
      }
      content: _rawContent
      title {
        title
        level
      }
      image {
        title
        image {
          alt
          asset {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 920, placeholder: BLURRED)
              }
            }
          }
        }
      }
    }
  }
`;

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    root: {
      margin: spacing(-2, 0),
      '> *': {
        margin: spacing(2, 0),
      },
    },
    buttons: {
      boxSizing: 'border-box',
      padding: spacing(0, 4),
    },
  } as const;
};

const EditoList: FunctionComponent<EditoListType> = (props) => {
  const { bottomText, upperText, editos, ctas } = props;
  const classes = useStyles();

  return (
    <BreakpointContainer padding={{ xs: [8, 0], md: [8, 4] }} width="100%" maxWidth="xl">
      <Flex flexDirection="column" width="100%" css={classes.root}>
        <Title title={props.title} standalone={!upperText} />

        <Description>{upperText}</Description>

        {editos?.map((edito, i) => (
          <Edito {...edito} reverse={i % 2 === 0} key={`edito-${i}`} />
        ))}

        <Description>{bottomText}</Description>

        <Flex width="100%" justifyContent="center" css={classes.buttons}>
          <Buttons ctas={ctas} />
        </Flex>
      </Flex>
    </BreakpointContainer>
  );
};

export default EditoList;
